const workerSwitch = (emailInput: string) => {
  let file = '';
  let phone = '';
  const email = emailInput.toLowerCase();

  switch (email) {
    case 'alexander.miller@meyle.com':
      file = 'AlexanderMiller_140x140_rund';
      phone = '+49 40 67506 588';
      break;

    case 'alexej.uwarow@meyle.com':
      file = 'AlexanderUwarow_140x140_rund';
      phone = '+49 40 67506 7455';
      break;

    case 'andre.sobottka@meyle.com':
      file = 'AndreSobottka_140x140_rund';
      phone = '+49 40 67506 7450';
      break;

    case 'andy.tress@meyle.com':
      file = 'AndrewTess_140x140_rund';
      phone = '+44 (0)1273 463686';
      break;

    case 'barney.dines@meyle.com':
      file = 'BarneyDines_140x140';
      phone = '+44 (0) 01273 444007';
      break;

    case 'bernd.lindemann@meyle.com':
      file = 'BerndLindemann_140x140_rund';
      phone = '+49 40 67506 576';
      break;

    case 'Boon-Khim.Ng@meyle.com':
      file = '';
      phone = '+60126651851';
      break;

    case 'christian.ludwig@meyle.com':
      file = 'ChristianLudwig_140x140_rund';
      phone = '+49 40 67506 513';
      break;

    case 'greg.kocik@meyle.com':
      file = 'GregKocik_140x140_rund';
      phone = '+44 (0)1273 463686';
      break;

    case 'ingo.koch@meyle.com':
      file = 'IngoKoch_140x140_rund';
      phone = '+49 40 67506 561';
      break;

    case 'jean-pierre.rodrigues@meyle.com':
      file = 'JeanPierreRodriques_140x140_rund';
      phone = '+33 5 61 63 31 52';
      break;

    case 'john.bowman@meyle.co.uk':
      file = 'JohnBowman_140x140';
      phone = '+44 (0)1273 463686';
      break;

    case 'joern.meyer@meyle.com':
      file = 'JoernMeyer_140x140_rund';
      phone = '+49 40 67506 578';
      break;

    case 'juergen.stelck@meyle.com':
      file = 'JuergenStelck_140x140_rund';
      phone = '+49 40 67506 565';
      break;

    case 'karim.guettai@meyle.com':
      file = 'KarimGuettai_140x140_rund';
      phone = '+49 40 67506 7492';
      break;

    case 'kirsten.rothe@meyle.com':
      file = 'KirstenRothe_140x140_rund';
      phone = '+49 40 67506 532';
      break;

    case 'maike.andresen@meyle.com':
      file = 'MaikeAndresen_140x140_rund';
      phone = '+49 40 67506 7465';
      break;

    case 'marcin.kondraciuk@meyle.com':
      file = 'MarcinKondraciuk_140x140_rund';
      phone = '+49 40 67506 7467';
      break;

    case 'marcus.winter@meyle.com':
      file = 'MarcusWinter_140x140_rund';
      phone = '+49 162 9409085';
      break;

    case 'mario.malz@meyle.com':
      file = 'MarioMalz_140x140_rund';
      phone = '+49 162 9248380';
      break;

    case 'maurizio.lagomarsini@meyle.com':
      file = 'MaurizioLagomarsini_140x140_rund';
      phone = '';
      break;

    case 'michal.korycki@meyle.com':
      file = 'MichaelKorycki_140x140_rund';
      phone = '+48 696 776 007';
      break;

    case 'miles.verrall@meyle.com':
      file = 'MilesVerrall_140x140_rund';
      phone = '+44 (0)1273 463686';
      break;

    case 'patrick.haberzettl@meyle.com':
      file = 'PatrickHaberzettl_140x140_rund';
      phone = '+49 173 6079573';
      break;

    case 'robert.castro@meyle.com':
      file = 'RobertCastro_140x140_rund';
      phone = '';
      break;

    case 'sebastien.vanparys@meyle.com':
      file = '';
      phone = '+33 5 61 63 31 52';
      break;

    case 'sven.nielsen@meyle.com':
      file = 'SvenNielsen_140x140_rund';
      phone = '+86 (0)21 5983 0792';
      break;

    case 'thomas.jochimski@meyle.com':
      file = 'ThomasJochimski_140x140_rund';
      phone = '+49 173 2189423';
      break;

    case 'eva.schilling@meyle.com':
      file = 'EvaSchilling_140x140_rund';
      phone = '+49 40 67506 7425';
      break;

    case 'jeannette.sanchez@meyle.com':
      file = 'JeanetteSanchez_140x140_rund';
      phone = '+49 40 67506 525';
      break;

    case 'andrea.kreinhacke@meyle.com':
      file = 'AndreaKreinhacke_140x140';
      phone = '+49 40 67506 568';
      break;

    case 'annadior.diallo@meyle.com':
      file = 'AnnaDiorDiallo_140x140';
      phone = '+49 40 67506 7480';
      break;

    case 'heike.birkner@meyle.com':
      file = 'HeikeBirkner_140x140_rund';
      phone = '+49 40 67506 526';
      break;

    case 'henri.saison@meyle.com':
      file = 'HenriSaison_140x140';
      phone = '+49 40 67506 7254';
      break;

    case 'nina.balzer@meyle.com':
      file = 'NinaBalzer_140x140';
      phone = '+49 40 67506 7489';
      break;

    case 'elena.schatz@meyle.com':
      file = 'ElenaSchatz_140x140';
      phone = '+49 40 67506 7220';
      break;

    case 'natalie.heintzenberg@meyle.com':
      file = 'NatalieHeintzenberg_140x140';
      phone = '+49 40 67506 593';
      break;

    case 'ines.westberg@meyle.com':
      file = 'InesWestberg_140x140';
      phone = '+49 40 67506 522';
      break;

    case 'britta.mohr@meyle.com':
      file = 'BrittaMohr_140x_140x_rund';
      phone = '+49 40 67506 7450';
      break;

    // Captains
    case 'andre.lang-herfurth@meyle.com':
      file = 'AndreLHerfurth_140x140_rund';
      break;

    case 'dennis.poersel@meyle.com':
      file = 'DennisPoersel_140x140_rund';
      break;

    case 'henning.gutzmann@emovum.com':
      file = 'HenningGutzmann_140x140_rund';
      break;

    case 'thorsten.rafalzik@meyle.com':
      file = 'ThorstenRafalzik_140x140_rund';
      break;

    case 'katharina.bolten@meyle.com':
      file = 'KatharinaBolten_140x140_rund';
      break;

    case 'wolfgang.kohne@meyle.com':
      file = 'WolfgangKohne_140x140_rund';
      break;

    case 'thomas.schwarz@meyle.com':
      file = 'ThomasSchwarz_140x140_rund';
      break;

    case 'patrick.stuedemann@meyle.com':
      file = 'PatrickStuedemann_140x140_rund';
      break;

    case 'michael.grimm@meyle.com':
      file = 'MichaelGrimm_140x140_rund';
      break;

    case 'marius.buechler@meyle.com':
      file = 'MariusBuechler_140x140_rund';
      break;

    case 'niklas.arndt@meyle.com':
      file = 'NiklasArndt_140x140_rund';
      break;

    case 'eric.gorlee@meyle.com':
      file = 'EricGorlee_140x140_rund';
      break;

    case 'soenke.schwenck@meyle.com':
      file = 'SoenkeSchwenk_140x140_rund';
      break;

    case 'joern.meyer2@meyle.com':
      file = 'JoernMeyer2_140x140_rund';
      break;

    case 'ulrich.beitzel@meyle.com':
      file = 'UlrichBeitzel_140x140_rund';
      break;

    case 'dimitri.knorr@meyle.com':
      file = 'DimitriKnorr_140x140_rund';
      break;

    case 'maximilian.volkmann@meyle.com':
      file = 'MaximilianVolkmann_140x140_rund';
      break;

    case 'jan-christopher.koelln@meyle.com':
      file = 'JanChristopherKölln_140x140_rund';
      break;

    case 'karsten.rau@meyle.com':
      file = 'KarstenRau_140x140_rund';
      break;

    case 'stefan.bachmann@meyle.com':
      file = 'SefanBachmann_140x140';
      break;

    case 'constaze.manner@meyle.com':
      file = '';
      break;

    default:
      file = '';
      phone = '';
      break;
  }

  return {
    file,
    phone
  };
};

export const getPortrait = (email: string) => {
  const { file } = workerSwitch(email);

  if (file === '') {
    return 'https://via.placeholder.com/140x140';
  }

  return require(`../assets/portraits/${file}.jpg`);
};

export const getPhone = (email: string) => {
  const { phone } = workerSwitch(email);

  return phone;
};
